/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpAdminStatsResponseTopPlayersInner } from './FuelUpAdminStatsResponseTopPlayersInner';
import {
    FuelUpAdminStatsResponseTopPlayersInnerFromJSON,
    FuelUpAdminStatsResponseTopPlayersInnerFromJSONTyped,
    FuelUpAdminStatsResponseTopPlayersInnerToJSON,
    FuelUpAdminStatsResponseTopPlayersInnerToJSONTyped,
} from './FuelUpAdminStatsResponseTopPlayersInner';
import type { FuelUpAdminStatsResponseBoardStats } from './FuelUpAdminStatsResponseBoardStats';
import {
    FuelUpAdminStatsResponseBoardStatsFromJSON,
    FuelUpAdminStatsResponseBoardStatsFromJSONTyped,
    FuelUpAdminStatsResponseBoardStatsToJSON,
    FuelUpAdminStatsResponseBoardStatsToJSONTyped,
} from './FuelUpAdminStatsResponseBoardStats';

/**
 * 
 * @export
 * @interface FuelUpAdminStatsResponse
 */
export interface FuelUpAdminStatsResponse {
    /**
     * Total users who have ever played FuelUp
     * @type {number}
     * @memberof FuelUpAdminStatsResponse
     */
    totalPlayers: number;
    /**
     * Players with active games in last 7 days
     * @type {number}
     * @memberof FuelUpAdminStatsResponse
     */
    activePlayers: number;
    /**
     * Total fuel stored across all vaults
     * @type {number}
     * @memberof FuelUpAdminStatsResponse
     */
    totalFuelInVaults: number;
    /**
     * Users who have prestiged at least once
     * @type {number}
     * @memberof FuelUpAdminStatsResponse
     */
    totalPrestigeUsers: number;
    /**
     * Average game progression level
     * @type {number}
     * @memberof FuelUpAdminStatsResponse
     */
    averageLevel?: number;
    /**
     * 
     * @type {Array<FuelUpAdminStatsResponseTopPlayersInner>}
     * @memberof FuelUpAdminStatsResponse
     */
    topPlayers?: Array<FuelUpAdminStatsResponseTopPlayersInner>;
    /**
     * 
     * @type {FuelUpAdminStatsResponseBoardStats}
     * @memberof FuelUpAdminStatsResponse
     */
    boardStats: FuelUpAdminStatsResponseBoardStats;
}

/**
 * Check if a given object implements the FuelUpAdminStatsResponse interface.
 */
export function instanceOfFuelUpAdminStatsResponse(value: object): value is FuelUpAdminStatsResponse {
    if (!('totalPlayers' in value) || value['totalPlayers'] === undefined) return false;
    if (!('activePlayers' in value) || value['activePlayers'] === undefined) return false;
    if (!('totalFuelInVaults' in value) || value['totalFuelInVaults'] === undefined) return false;
    if (!('totalPrestigeUsers' in value) || value['totalPrestigeUsers'] === undefined) return false;
    if (!('boardStats' in value) || value['boardStats'] === undefined) return false;
    return true;
}

export function FuelUpAdminStatsResponseFromJSON(json: any): FuelUpAdminStatsResponse {
    return FuelUpAdminStatsResponseFromJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpAdminStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPlayers': json['totalPlayers'],
        'activePlayers': json['activePlayers'],
        'totalFuelInVaults': json['totalFuelInVaults'],
        'totalPrestigeUsers': json['totalPrestigeUsers'],
        'averageLevel': json['averageLevel'] == null ? undefined : json['averageLevel'],
        'topPlayers': json['topPlayers'] == null ? undefined : ((json['topPlayers'] as Array<any>).map(FuelUpAdminStatsResponseTopPlayersInnerFromJSON)),
        'boardStats': FuelUpAdminStatsResponseBoardStatsFromJSON(json['boardStats']),
    };
}

export function FuelUpAdminStatsResponseToJSON(json: any): FuelUpAdminStatsResponse {
    return FuelUpAdminStatsResponseToJSONTyped(json, false);
}

export function FuelUpAdminStatsResponseToJSONTyped(value?: FuelUpAdminStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPlayers': value['totalPlayers'],
        'activePlayers': value['activePlayers'],
        'totalFuelInVaults': value['totalFuelInVaults'],
        'totalPrestigeUsers': value['totalPrestigeUsers'],
        'averageLevel': value['averageLevel'],
        'topPlayers': value['topPlayers'] == null ? undefined : ((value['topPlayers'] as Array<any>).map(FuelUpAdminStatsResponseTopPlayersInnerToJSON)),
        'boardStats': FuelUpAdminStatsResponseBoardStatsToJSON(value['boardStats']),
    };
}

